export const FOOTER_INFO_BANNER_HEIGHT = 50;
